<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入分类名称" />
      </a-form-model-item>
      <a-form-model-item label="请选择上级" prop="parentId" >
        <a-select v-model="form.parentId" placeholder="请选择上级分类">
          <a-select-option value="0">顶级分类</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="保险分类" prop="insurance" >
        <a-select v-model="form.insurance" placeholder="请选择保险分类">
          <a-select-option :value="1">A类</a-select-option>
          <a-select-option :value="2">B类</a-select-option>
          <a-select-option :value="3">C类</a-select-option>
          <a-select-option :value="4">D类</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="层级" prop="status" >
        <a-select v-model="form.status" placeholder="请选择层级">
          <a-select-option :value="0">顶级</a-select-option>
          <a-select-option :value="1">一级</a-select-option>
          <a-select-option :value="2">二级</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCategory, addCategory, updateCategory, listCategory} from '@/api/category/category'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      categoryList: [],
      // 表单参数
      form: {
        id: null,
        name: null,
        parentId: null,
        certificate: null,
        insurance: null,
        certificateName: null,
        type: 2,
        status: null,
        insuranceMoney: null,
        suretyMoney: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '工种名称不能为空', trigger: 'blur' }
        ],
        insurance: [
          { required: true, message: '保险分类不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1

      this.$nextTick(() => {
        this.form = {
          id: null,
          name: null,
          parentId: undefined,
          certificate: null,
          insurance: undefined,
          certificateName: null,
          type: 2,
          status: undefined,
          insuranceMoney: null,
          suretyMoney: null,
          createTime: null,
          remark: null,
        }
      })
    },

    getCategoryList(){
      listCategory({type: 0}).then(response => {
        this.categoryList = response.data
      })
    },

    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getCategoryList()
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCategory({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
